import common from './common.json';
import page from './page.json';
import plans from './plans.json';
import comparison from './comparison.json';
import planDetails from './planDetails.json';
import countries from './countries.json';
import compare from './compare.json';

export { common, page, plans, comparison, planDetails, countries, compare };
